import { RawResponse, toGsResponse } from '../../goodstack'

import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { Money } from '@percent/utility'

export type DonationWalletResponse = {
  id: string
  accountId: string
  partnerId: string
  balance: Money
}

export const donationWallet: QueryFn<[string], DonationWalletResponse | undefined> = async client => {
  return client
    .get<RawResponse<DonationWalletResponse>>('v1/account/donation-wallet', {
      validateStatus: code => [200, 403, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r.data : undefined))
}

export type WalletAllocation = {
  id: string
  amount: Money
  remainingAmount: Money
  fundedAt: string
  expiresAt: string | null
  fundingSourceId: string | null
  fundingSourceName: string | null
  isExpired: boolean
}

export type WalletAllocations = {
  allocations: WalletAllocation[]
  totalBalance: Money
}

export const donationWalletAllocations: QueryFn<
  [string, { includeExpired: boolean }],
  WalletAllocations | undefined
> = async (client, [, { includeExpired }]) => {
  return client
    .get<RawResponse<WalletAllocations>>('v1/account/donation-wallet/allocations', {
      params: { includeExpired: includeExpired ? 'true' : 'false' },
      validateStatus: code => [200, 403, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r.data : undefined))
}
